import { apiClient } from '../../../gateways/api'

export { updateMyList }

const updateMyList = async ({
  aanvraagID,
  method,
}: {
  aanvraagID: string
  method: 'add' | 'remove'
}): Promise<{ projecten: string[] }> => {
  const { data } = await apiClient<{ projecten: string[] }>({
    url: `/rest/my-list`,
    method: method === 'remove' ? 'DELETE' : 'POST',
    data: { id: aanvraagID },
  })

  return data
}
